import React, {
  FunctionComponent, useEffect, useRef, useState,
} from 'react';
import Collapsible from 'react-collapsible';
import { Box, Flex, Text } from 'rebass/styled-components';
import { CollapsibleDrawerArrow } from '..';

export interface CollapsibleCredentialsProps {
  trigger: string;
  content: React.ReactNode;
  credentialType: string;
}

const CollapsibleCredentials: FunctionComponent<CollapsibleCredentialsProps> = ({
  trigger, content, credentialType,
}: CollapsibleCredentialsProps) => {
  const [isDrawerOpen, setDrawerOpen] = useState<boolean>(false);
  const isMounted = useRef<boolean>(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <Box mt={5}>
      <Collapsible
        transitionTime={150}
        onOpening={() => {
          if (isMounted.current) {
            setDrawerOpen(true);
          }
        }}
        onClosing={() => {
          if (isMounted.current) {
            setDrawerOpen(false);
          }
        }}
        trigger={(
          <Flex mt={3} sx={{ cursor: 'pointer' }} data-testid={`${credentialType}-credentials-trigger`}>
            <Text variant="h2" mr={3}>
              {trigger}
            </Text>
            <Text variant="h2">
              <CollapsibleDrawerArrow isOpen={isDrawerOpen} />
            </Text>
          </Flex>
      )}
      >
        {content}
      </Collapsible>
    </Box>
  );
};

export default CollapsibleCredentials;
